import { Button, Grid, InputLabel, ListItem, MenuItem, Select } from '@material-ui/core'
import React, { Component } from 'react'
import { EditableReactSelect } from '../common/EditableComponents'

class AddShop extends Component {
  state = {
    selectedShop: { label: null, value: '' },
  }

  handleChange(value) {
    this.setState({ selectedShop: { ...value } })
  }

  getShopsAvailable(shopsList = [], settingsList = []) {
    if (shopsList.length > 0) {
      return shopsList.filter(
        (s) =>
          !settingsList.map((c) => c.shopId).includes(s.id) && s.active && s.appTarget === 'Retail',
      )
    }
    return []
  }
  render() {
    const { operAddShopModal, cancelShop, shopsList, settingsList } = this.props
    const { selectedShop } = this.state

    const shopsAvailableToSave = this.getShopsAvailable(shopsList, settingsList)
    return (
      <Grid container className="listing-spacing">
        <ListItem>
          <Grid container>
            <Grid className="labelField" item xs={12} sm={8} md={8} lg={8}>
              <Grid container direction="row">
                <Grid
                  className="labelField"
                  item
                  xs={12}
                  sm={5}
                  md={5}
                  lg={5}
                  style={{ paddingTop: '12px' }}
                >
                  <div style={{ marginBottom: 3 }}>Select Shop</div>
                </Grid>
                <Grid
                  className="editField"
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  style={{ paddingTop: '12px' }}
                >
                  <EditableReactSelect
                    placeholder={'Select a Shop'}
                    clearable={false}
                    multi={false}
                    valueToRender={selectedShop.label}
                    editMode={true}
                    value={selectedShop}
                    onChange={(value) => {
                      this.handleChange(value)
                    }}
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    options={
                      shopsAvailableToSave &&
                      shopsAvailableToSave.length &&
                      shopsAvailableToSave.map((shop, i) => {
                        return { label: shop.name, value: shop.id }
                      })
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4} style={{ paddingTop: '5px' }}>
              <Button className="button-white-and-red margin btn-border" onClick={cancelShop}>
                {' '}
                Cancel{' '}
              </Button>
              <Button
                className="primary-button margin btn-border"
                onClick={() => operAddShopModal((selectedShop && selectedShop.value) || '')}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </ListItem>
      </Grid>
    )
  }
}

export default AddShop



// WEBPACK FOOTER //
// ./src/components/WmDispatch/AddShop.js